import React, { useContext } from 'react';
import { Box } from '@rebass/grid';
import { Header } from '../../components';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';

const Contact = () => {
    const {t} = useTranslation();
    const {brand} = useContext(ThemeContext);

    return <Box id="box-contact" data-page-id="contact">
    <Box width={800} marginLeft={'auto'} marginRight={'auto'} backgroundColor={'white'} padding={20}>
        <Header>{t("CONTACT")}</Header>
        <p>{brand === 'brenntag' ? t("CONTACT_US_AT_BRENNTAG") : t("CONTACT_US_AT_BCD")}</p>
    </Box>
</Box>
}

export default Contact;